// extracted by mini-css-extract-plugin
export default {"dialogmainwrapper":"usermodal_dialogmainwrapper__51UUO","btns":"usermodal_btns__zHo6C"};